(function () {
  function setYear() {
    var year = new Date().getFullYear();
    var els = document.querySelectorAll('.current_year, .current_year2');
    Array.prototype.forEach.call(els, function (el) { el.textContent = year; });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setYear);
  } else {
    setYear();
  }
})();